import {API_URL, API_URL_V3} from '../constants/index.js';
import {
    GET_HOME_APPS,
    GET_HOME_APPS_SUCCESS,
    GET_HOME_APPS_ERROR,
    GET_TV_HOME_APPS,
    GET_TV_HOME_APPS_SUCCESS,
    GET_TV_HOME_APPS_ERROR,
    UPDATE_HOME_APPS_COMMUNITY,
    UPDATE_HOME_APPS_COMMUNITY_SUCCESS,
    UPDATE_HOME_APPS_COMMUNITY_ERROR,
    UPDATE_TV_HOME_APPS_COMMUNITY,
    UPDATE_TV_HOME_APPS_COMMUNITY_SUCCESS,
    UPDATE_TV_HOME_APPS_COMMUNITY_ERROR
    } from '../constants/homeAppsConstants';

import {sweetAlert} from '../components/Alert/sweetAlert'


    
//#region GET HOME APPS
export function getHomeApps(data) {
    return {
        type: GET_HOME_APPS,
        data
    }
};

export function getHomeAppsSuccess(data) {
    return {
        type: GET_HOME_APPS_SUCCESS,
        data
    }
};

export function getHomeAppsError(data) {
    return {
        type: GET_HOME_APPS_ERROR,
        data
    }
};

export function GetHomeApps(idCommunity, residentId) {

    let headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
        'communityid': idCommunity, 
    }

    if(residentId){
        headers ={ 
            'Content-Type':'application/json' ,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Authorization': 'Bearer '+localStorage.getItem('token'),
            'communityid': idCommunity, 
            'residentid': residentId,
        }
    }

    return dispatch => {
        dispatch(getHomeApps());

        return fetch(API_URL+'apps',
        {
            method: 'GET',
            headers:  headers
        }
        )
        .then(res => res.json())
        .then(res => {
            dispatch(getHomeAppsSuccess(res));
            return res;
        })
        .catch(error => {
            dispatch(getHomeAppsError(error));

        })
    }
};

//#endregion
   

//#region GET TV HOME APPS
export function getTvHomeApps(data) {
    return {
        type: GET_TV_HOME_APPS,
        data
    }
};

export function getTvHomeAppsSuccess(data) {
    return {
        type: GET_TV_HOME_APPS_SUCCESS,
        data
    }
};

export function getTvHomeAppsError(data) {
    return {
        type: GET_TV_HOME_APPS_ERROR,
        data
    }
};

export function GetTVHomeApps(idCommunity) {

    let headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
        'communityid': idCommunity, 
    }

    return dispatch => {
        dispatch(getTvHomeApps());

        return fetch(API_URL_V3+'home-app',
        {
            method: 'GET',
            headers:  headers
        }
        )
        .then(res => res.json())
        .then(res => {
            dispatch(getTvHomeAppsSuccess(res));
            return res;
        })
        .catch(error => {
            dispatch(getTvHomeAppsError(error));

        })
    }
};

//#endregion
   

//#region UPDATE TV HOME APPS
export function updTvHomeApps(data) {
    return {
        type: UPDATE_TV_HOME_APPS_COMMUNITY,
        data
    }
};

export function updTvHomeAppsSuccess(data) {
    return {
        type: UPDATE_TV_HOME_APPS_COMMUNITY_SUCCESS,
        data
    }
};

export function updTvHomeAppsError(data) {
    return {
        type: UPDATE_TV_HOME_APPS_COMMUNITY_ERROR,
        data
    }
};

export function UpdTVHomeApps(data, communityId) {

    let headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
        'communityid': communityId
    }

    return dispatch => {
        dispatch(updTvHomeApps());

        return fetch(API_URL_V3+'home-apps',
        {
            method: 'PUT',
            body:JSON.stringify(data),
            headers:  headers
        }
        )
        .then(res => res.json())
        .then(res => {
            dispatch(updTvHomeAppsSuccess(res));
            return res;
        })
        .catch(error => {
            dispatch(updTvHomeAppsError(error));

        })
    }
};

//#endregion
   


//#region UPDATE  HOME APPS -COMMUNITY-
export function updateHomeAppByCommunity(data) {
    return {
        type: UPDATE_HOME_APPS_COMMUNITY,
        data
    }
};

export function updateHomeAppByCommunitySuccess(data) {
    return {
        type: UPDATE_HOME_APPS_COMMUNITY_SUCCESS,
        data
    }
};

export function updateHomeAppByCommunityError(data) {
    return {
        type: UPDATE_HOME_APPS_COMMUNITY_ERROR,
        data
    }
};

export function UpdateHomeAppByCommunity(homeAppsData, communityId, residentId, userName, styles = '') {
    let headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
        'communityid': communityId, 
        'userName': userName
    }

    if(residentId){
        headers ={ 
            'Content-Type':'application/json' ,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Authorization': 'Bearer '+localStorage.getItem('token'),
            'communityid': communityId, 
            'residentid': residentId,
            'userName': userName
        }
    }
   
    return dispatch => {
        dispatch(updateHomeAppByCommunity());

        return fetch(API_URL+`home-appAvailable`,
        {
            method: 'PUT',
            body: JSON.stringify(homeAppsData),
            headers: headers
        })
        .then(() => {
            dispatch(updateHomeAppByCommunitySuccess({}));

            const message='The Home apps updated successfully';
            sweetAlert('success',message, 'alert_UpdateHomeApps_Success', styles);
        })
        .catch(error => {
            dispatch(updateHomeAppByCommunityError(error));

            const message = 'An error occurred while updating, please try again later.';
            sweetAlert('error',message, 'alert_UpdateHomeApps_Error', styles);
        })
    }
};

//#endregion

//#region UPDATE  HOME APPS -RESIDENT-
// export function updateHomeAppByResident(data) {
//     return {
//         type: UPDATE_HOME_APPS_RESIDENT,
//         data
//     }
// };

// export function updateHomeAppByResidentSuccess(data) {
//     return {
//         type: UPDATE_HOME_APPS_RESIDENT_SUCCESS,
//         data
//     }
// };

// export function updateHomeAppByResidentError(data) {
//     return {
//         type: UPDATE_HOME_APPS_RESIDENT_ERROR,
//         data
//     }
// };

// export function UpdateHomeAppByResident(residentId,communityId, idHomeApp) {
   
//     return dispatch => {
//         dispatch(updateHomeAppByResident());

//         return fetch(API_URL+`updResidentHomeApp/${idHomeApp}`,
//         {
//             method: 'PUT',
//             headers: { 
//                 'Content-Type':'application/json' ,
//                 'Authorization': 'Bearer '+localStorage.getItem('token'),
//                 'communityid': communityId, 
//                 'residentid': residentId,
//             }
//         })
//         .then(() => {
//             dispatch(updateHomeAppByResidentSuccess({}));
//             this.GetHomeApps(communityId);
//         })
//         .catch(error => {
//             dispatch(updateHomeAppByResidentError(error));

//         })
//     }
// };
//#endregion